import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CookieService } from "ngx-cookie-service";
import { UserUtil } from '../utils/user.utils';

@Injectable()
export class ProfileGuard implements CanActivate {
  constructor(private userUtil: UserUtil) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let user = this.userUtil.getUser();
    return route.data.expectedRole?.some(
      (role: string) => user.profiles?.includes(role)
    )
  }
}
